// Lightweight GA4 helper. index.html loads gtag.js with send_page_view:false
// so we control page_view + conversion events explicitly (required for an
// SPA — client-side route changes don't trigger a new page load).

export function trackPageView(path, title) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { page_path: path, page_title: title || document.title, page_location: window.location.href });
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
}
